module.exports = __webpack_public_path__ + "img/federacion.2512fe16.svg";